import React from "react";

import OrderStatusRequestForm from "./OrderStatusRequestForm";
import OrderStatusResultForm from "./OrderStatusResultForm";

function OrderStatusForm({ order = null, values = {}, onChange, onSubmit }) {

  if (order && order[0]) {
    return order.map(d => (
      <OrderStatusResultForm
        key={d.orderUid}
        order={d}
        values={values}
      />
    ));
  }

  return (
    <OrderStatusRequestForm
      values={values}
      onChange={onChange}
      onSubmit={onSubmit}
    />
  );
}

export default OrderStatusForm;
